'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoHelpBuoy = function IoHelpBuoy(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.5 2.5c9.7 0 17.5 7.8 17.5 17.5s-7.8 17.5-17.5 17.5-17.5-7.8-17.5-17.5 7.8-17.5 17.5-17.5z m13.9 11.9c-0.8-1.9-1.8-3.5-3.3-5s-3.2-2.5-5.1-3.3l-1.4 4.8c1.1 0.4 2.1 1.1 2.9 2s1.7 1.9 2.1 3z m-13.9 13.1c4.1 0 7.5-3.4 7.5-7.5s-3.4-7.5-7.5-7.5-7.5 3.4-7.5 7.5 3.4 7.5 7.5 7.5z m-10.6-18.1c-1.5 1.5-2.5 3.2-3.3 5.1l4.8 1.4c0.4-1.1 1.1-2.1 2-2.9s1.9-1.7 3-2.1l-1.5-4.8c-1.9 0.8-3.5 1.8-5 3.3z m-3.3 16.2c0.8 1.9 1.8 3.5 3.3 5s3.2 2.5 5.1 3.3l1.4-4.8c-1.1-0.4-2.1-1.1-2.9-2s-1.7-1.9-2.1-3z m24.5 5c1.5-1.5 2.5-3.2 3.3-5.1l-4.8-1.4c-0.4 1.1-1.1 2.1-2 2.9s-1.9 1.7-3 2.1l1.5 4.8c1.9-0.8 3.5-1.8 5-3.3z' })
        )
    );
};

exports.default = IoHelpBuoy;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/help-buoy.js
// module id = 2044
// module chunks = 0